"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PreloaderEvents = void 0;
var _Mp4PlayableDB = _interopRequireDefault(require("./Mp4PlayableDB"));
var _eventEmitter = _interopRequireDefault(require("event-emitter"));
var _QualityUtils = require("../QualityUtils");
var _Mp4PreloaderConfig = require("./types/Mp4PreloaderConfig");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // @ts-ignore
// @ts-ignore
var PreloaderEvents = exports.PreloaderEvents = /*#__PURE__*/function (PreloaderEvents) {
  PreloaderEvents["FilePreloading"] = "filepreloading";
  PreloaderEvents["FilePreloaded"] = "filepreloaded";
  PreloaderEvents["FileQueued"] = "filequeued";
  PreloaderEvents["FileSkipped"] = "fileskipped";
  return PreloaderEvents;
}({});
;
var Mp4Preloader = /*#__PURE__*/function () {
  /**
   * A percentage of how much content of the currently playing file must be buffered before preloading
   * can start (from 0.0 to 1.0). Initial state comes from `Mp4PreloaderConfig`.
   */

  /**
   * The number of MP4 playables to preload in series after the currently playing file is X% buffered.
   * Initial state comes from `Mp4PreloaderConfig`.
   */

  function Mp4Preloader(preloaderConfig, logger) {
    _classCallCheck(this, Mp4Preloader);
    /**
     * Controls whether or not the MP4 preloader is used. Initial state comes from `Mp4PreloaderConfig`.
     */
    /**
     * IndexedDb instance that contains the list of files to preload
     */
    /**
     * Emits various preloading events so they can be listened for
     */
    /**
     * Instance of logger to use when needing to log actions to collector
     */
    /**
     * A queue of the next N files to preload when there's free bandwidth.
     * Note: mp4PlayableDbRequestQueue is cleared with each call to queuePreloadsFromIndex.
     */
    _defineProperty(this, "mp4PlayableDbRequestQueue", []);
    this.eventEmitter = new _eventEmitter["default"]();
    this.logger = logger;
    this.mp4PlayableDb = new _Mp4PlayableDB["default"](logger);
    var computedConfig = _objectSpread(_objectSpread({}, _Mp4PreloaderConfig.DefaultMp4PreloaderConfig), preloaderConfig || {
      enabled: false
    });
    this.enabled = computedConfig.enabled;
    this.numberOfMp4PlayablesToPreload = computedConfig.numberOfMp4PlayablesToPreload;
    this.minBufferPercentageBeforePreload = computedConfig.minBufferPercentageBeforePreload;
    this._setUpDb();
  }

  /**
   * Adds an event listener for a particular event.
   * @param {string} event - The event to listen to
   * @param {function} callback - The callback to be run when the event occurs
   */
  return _createClass(Mp4Preloader, [{
    key: "addEventListener",
    value: function addEventListener(event, callback) {
      if (!this.enabled) {
        return;
      }
      this.eventEmitter.on(event, callback);
    }

    /**
     * The callback that hooks into the player's buffered event so that preloading can start from a point when video is sufficiently buffered
     * @param event
     */
  }, {
    key: "playerBufferedPercentCallback",
    value: function playerBufferedPercentCallback(event) {
      if (!this.enabled || event.percent <= this.minBufferPercentageBeforePreload) {
        return;
      }
      this._preloadNextFileIfNothingInProgress();
    }

    /**
     * Resets the playables list so that we can set the right list from source
     * @param playables
     */
  }, {
    key: "setPlayables",
    value: function setPlayables(playables) {
      if (!this.enabled) {
        return;
      }
      this.playables = playables;
    }

    /**
     * Dump the next X files after the current playable's index into the local db request queue, so that
     * they can be preloaded by calling `_loadFile`. Clears any outdated preload requests from the queue.
     */
  }, {
    key: "queuePreloadsFromIndex",
    value: function queuePreloadsFromIndex(index) {
      try {
        if (!this.enabled || !this.playables || index >= this.playables.length - 1) {
          return;
        }
        this.mp4PlayableDbRequestQueue = [];
        var preloader = this;
        var lastIndex = Math.min(index + this.numberOfMp4PlayablesToPreload, this.playables.length - 1);
        for (var i = index + 1; i <= lastIndex; i++) {
          var content = {
            index: i,
            src: this.playables[i].src
          };
          if ((0, _QualityUtils.isHLS)(content.src)) {
            preloader.eventEmitter.emit(PreloaderEvents.FileSkipped, content);
            continue;
          }
          if (!this._contentIsAlreadyQueuedOrLoaded(content)) {
            preloader.eventEmitter.emit(PreloaderEvents.FileQueued, content);
            preloader.mp4PlayableDbRequestQueue.push(content);
          }
        }
        this.mp4PlayableDb.abortCurrentPreloadRequestIfOutdated(this.mp4PlayableDbRequestQueue.map(function (request) {
          return request.src;
        }));
      } catch (e) {}
    }

    /**
     * Gets the blob URL if the file is pre-loaded into indexedDb, otherwise returns the file URL as is.
     * @param fileUrl
     */
  }, {
    key: "getPreloadedFile",
    value: function getPreloadedFile(fileUrl, callback) {
      // return early if disabled, falsey fileUrl, or HLS format to avoid hitting IndexedDB
      if (!this.enabled || !fileUrl || (0, _QualityUtils.isHLS)(fileUrl)) {
        callback(fileUrl, false);
        return;
      }
      this.mp4PlayableDb.retrieveFile(fileUrl, function (str) {
        callback(str, true);
      }, function () {
        callback(fileUrl, false);
      });
    }

    /**
     * Cancel in-progress preloads
     */
  }, {
    key: "abortCurrentPreloadRequest",
    value: function abortCurrentPreloadRequest() {
      if (!this.enabled) {
        return;
      }
      this.mp4PlayableDb.abortCurrentPreloadRequest();
    }

    /**
     * Set up IndexedDb for file requests
     */
  }, {
    key: "_setUpDb",
    value: function _setUpDb() {
      var _this = this;
      if (!this.enabled) {
        return;
      }
      try {
        this.mp4PlayableDb.readyDB(function (useDb) {
          _this.enabled = useDb;
        });
      } catch (e) {
        var message = 'failed to load indexedDB';
        if (e && e.message) {
          message = "".concat(message, ": ").concat(e.message);
        }
        var logData = {
          Error: true,
          VideoPlaybackPlayer: true,
          Message: message
        };
        this.logger.logIssue('IndexedDBError', logData);
        this.enabled = false;
        console.log(message);
      }
    }

    /**
     * Adds the given file to the Mp4PlayableDB request queue if the provided queue is still current
     * On success, it will continue to load the next file in the queue
     */
  }, {
    key: "_loadFile",
    value: function _loadFile(content, queueAtTime) {
      var _this2 = this;
      if (!content || !content.src) {
        return;
      }
      this.mp4PlayableDb.isFileCached(content.src, function (isAlreadyCached) {
        if (!isAlreadyCached) {
          var preloader = _this2;
          preloader.eventEmitter.emit(PreloaderEvents.FilePreloading, content);

          // If the file is not preloaded yet, preload it
          _this2.mp4PlayableDb.addFile(content.src, function () {
            //emit a preloaded event this way the events can be emitted up the chain
            preloader.eventEmitter.emit(PreloaderEvents.FilePreloaded, content);

            // If there are more queued and the queue is still current to the latest
            if (queueAtTime.length && queueAtTime.length === preloader.mp4PlayableDbRequestQueue.length) {
              // Ensure that all items in both queues are equal and in the same order
              for (var i = 0; i < queueAtTime.length; i++) {
                if (queueAtTime[i] !== preloader.mp4PlayableDbRequestQueue[i]) return;
              }
              preloader._loadNextFile();
            }
          });
        } else {
          // If the file has already been preloaded, attempt to preload the next file in the queue
          _this2._loadNextFile();
        }
      }, function () {
        console.log('Error checking for existence of key in db');
      });
    }
  }, {
    key: "_contentIsAlreadyQueuedOrLoaded",
    value: function _contentIsAlreadyQueuedOrLoaded(content) {
      for (var i = 0; i < this.mp4PlayableDbRequestQueue.length; i++) {
        var queuedContent = this.mp4PlayableDbRequestQueue[i];
        if (content.src === queuedContent.src) {
          return true;
        }
      }
      var preloader = this;
      var queuedOrLoaded = false;
      this.mp4PlayableDb.isFileCached(content.src, function (isAlreadyCached) {
        if (isAlreadyCached) {
          preloader.eventEmitter.emit(PreloaderEvents.FilePreloaded, content);
          queuedOrLoaded = true;
          return;
        }
        queuedOrLoaded = false;
      }, function () {
        console.log('Error checking for existence of key in db');
        queuedOrLoaded = true;
      });
      return queuedOrLoaded;
    }

    /**
     * Preloads the next file from the Mp4PlayableDB request queue when no file requests are already in progress
     */
  }, {
    key: "_preloadNextFileIfNothingInProgress",
    value: function _preloadNextFileIfNothingInProgress() {
      if (this.mp4PlayableDb.isFileBeingPreloaded()) {
        return;
      }
      this._loadNextFile();
    }
  }, {
    key: "_loadNextFile",
    value: function _loadNextFile() {
      if (this.mp4PlayableDbRequestQueue && this.mp4PlayableDbRequestQueue.length) {
        this._loadFile(this.mp4PlayableDbRequestQueue.shift(), this.mp4PlayableDbRequestQueue);
      }
    }
  }]);
}();
var _default = exports["default"] = Mp4Preloader;